<template>
  <b-card header="Donation Statistics (Last 12 Months)" class="mb-3">
    <apexchart
      v-if="series.length > 0"
      type="bar"
      height="350"
      :options="chartOptions"
      :series="series"
    />
    <div v-else class="text-center text-muted py-5">No data available</div>
  </b-card>
</template>

<script>
export default {
  props: {
    data: { type: Array, default: () => [] },
  },
  computed: {
    chartOptions() {
      return {
        chart: { id: "donation-bar", toolbar: { show: false } },
        xaxis: {
          categories: this.data.map(
            (d) => d.month_name || `${d.month}/${d.year}`
          ),
        },
        colors: ["#007bff"],
        plotOptions: {
          bar: { borderRadius: 4, columnWidth: "60%" },
        },
        dataLabels: { enabled: false },
      };
    },
    series() {
      if (!this.data.length) return [];
      return [
        {
          name: "Donations",
          data: this.data.map((d) => Number(d.count) || 0),
        },
      ];
    },
  },
};
</script>
